/**
 * Reloads the window if detects a new version is available
 */

import axios from 'axios';
import { defer } from 'lodash';
import { saveStoreState } from '../data/persist/store-state';
import appPath from './appPath';
const LAST_UPDATE_STORAGE_KEY = 'LAST_UPDATED_TO_VERSION';
const CHECK_UPDATES_INTERVAL = 1 * 60 * 1000;

let checkingForUpdates = false,
    checkUpdatesIntervalID;
async function checkUpdates() {
    // don't try to update app if it's busy doing stuff
    let state = app.store.getState();
    if (state.ui.pendingTasks || state.ui.virtualRoom) return;

    // check flag to avoid more than one check if network has issues
    if (checkingForUpdates) return;
    checkingForUpdates = true;

    await axios({
        url: appPath('version'),
        method: 'get',
    })
        .then((response) => response.data)
        .then((availableVersion) => {
            let lastUpdate = sessionStorage.getItem(LAST_UPDATE_STORAGE_KEY);
            if (__VERSION__ != availableVersion && availableVersion != lastUpdate) {
                console.warn(`App was updated from ${__VERSION__} to ${availableVersion}: updating next time window loses focus`);
                clearInterval(checkUpdatesIntervalID);

                let updaterCallback = () => hardUpdate(availableVersion);

                sessionStorage.setItem(LAST_UPDATE_STORAGE_KEY, availableVersion);

                if (document.hasFocus()) {
                    window.addEventListener('blur', updaterCallback, false);
                } else {
                    updaterCallback();
                }
            }
        })
        .catch(console.error)
        .then(() => (checkingForUpdates = false));
}
defer(() => {
    // Interval to check for updates
    checkUpdatesIntervalID = setInterval(checkUpdates, CHECK_UPDATES_INTERVAL);

    // Initial check when app is ready and idle
    let unsubscribe = app.store.observe(
        (state) => state.ui.pendingTasks,
        (pendingTasks) => {
            if (!app.history) return;
            if (pendingTasks) return;
            unsubscribe();
            checkUpdates();
        }
    );

    // Clear interval on shutdown
    app.onShutdown(() => clearInterval(checkUpdatesIntervalID));
});

function hardUpdate(newVersion) {
    console.log(`\n\nUpdating app to ${newVersion} (hard update)\n\n`);
    saveStoreState();
    location.reload(true);
}
